import { ListResult } from "@/common/models";
import { SharedState } from "@/common/state";
import { cord, formatInput, gql2 } from "@/gql/lib";
import {
  ActionEnum,
  AxisType,
  CountOrderByEnum,
  Direction,
  QueryTier1countArgs,
  targetAxis,
} from "@/gql/types";

export const get_info_type_count_for_source = gql2<string, ListResult<any>>(
  "entities.get",
  (source, { frame, allInfoTypes }) => {
    const l0_ids = SharedState.l0_known_content_info_types.value.map(
      (d) => d.id
    );
    const q: QueryTier1countArgs = {
      params: {
        coordinate: {
          x: cord(AxisType.Application, [source]),
          y: {
            type: AxisType.ContentLabel,
            values: l0_ids,
          },
          z: frame,
        },
        action: ActionEnum.List,
        targetAxis: targetAxis.X,
        direction: Direction.Descend,
        orderBy: CountOrderByEnum.Count,
      },
    };
    return {
      query: `{
        #EXPORT
        sources: tier1count(params:${formatInput(q.params)}){
            count
            files
            startDate
            endDate
            y{value}
            x{value}
          }
          #EXPORT_END
        }`,
      mapper: (res) => {
        return {
          cursor: "",
          objects: res.sources
            .map((item: any) => {
              const l0_id = item.y.value;
              return {
                count: item.count,
                files: item.files,
                id: l0_id,
                order: allInfoTypes[l0_id].l0Order,
                startDate: item.startDate,
                endDate: item.endDate,
                l0: allInfoTypes[l0_id],
              };
            })
            // @ts-ignore
            .sort((a, b) => b.count - a.count),
        };
      },
    };
  }
);
